<template>
  <div class="container page" style="background-color: #000000;">
    <van-nav-bar :title="$t('q32')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-content">
      <div class="item" @click="toLink('/Infomation')">

        <div class="left">{{$t('q33')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item-border"></div>
      <div class="item" @click="toLink('/SetLoginPassword')">
        <div class="left">{{$t('q34')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item-border"></div>
      <div class="item" @click="toLink('/SetPayPassword')">
        <div class="left">{{$t('q35')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="btn_out">
       <van-button  @click="loginout()" >
                {{$t("setting.logout")}}
        </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {}
    };
  },
  methods: {
    loginout() {
      localStorage.clear()
      this.$router.push({ path: '/Login' });
    },
    toLink(path){
      this.$router.push({path:path});
    },
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({ path: '/Setname' });
    },
    toSetBank() {
      this.$router.push({ path: '/Setbank' });
    },
    toSetSex() {
      this.$router.push({ path: '/Setsex' });
    },
    select_header_img(url) {
      this.isActive = url;
    },
    check() {
      this.$http({
        method: 'post',
        data: { header_img: this.isActive },
        url: 'user_header_img'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.isBank = true;
          } else {
            this.isBank = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.item-border{
  height: 1px;
  width: 96%;
  background-color: #1a1a1a;
  margin-left: 4%;
}
.btn_out{
  ::v-deep .van-button{
    margin: 26px 20px;
    background: #c9a84c !important;
    color: #000;
     .van-button__text{
      color: #fff;
      padding: 10px 0;
    }
    font-size: 30px;
    border: none;
    width: calc(100% - 40px);
    padding: 20px 0;
    height: initial;
    border-radius: 50px;
  }
  
}

.container .main-content {
  padding: 0 20px;
  background: #141414 !important;
  color: #c9a84c;
}

.container .main-content .item {
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
}

.container .main-content .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.container .main-content .item .right img {
  width: 90px;
}

.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.container .main-content .item .right .desc-cell-number,
.container .main-content .item .right .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}

.avatarbox {
  padding: 15px;
  color: #000;
  height: 81%;
  background-color: #141414;
}

.avatarbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.avatarbox .content .van-image {
  width: 105px;
  height: 105px;
  margin: 2.5%;
  border-radius: 50%;
}

.avatarbox .content {
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.avatarbox .content .choose {
  width: 95px;
  height: 95px;
  border: 6px solid #c9a84c;
}
</style>
